/** * @author Bhavani Naralasetty * @email Bhavani.Naralaseetty@ul.com * @create date 2020-11-09
11:25:44 * @modify date 2020-11-09 11:25:44 * @desc welcome virtual tour popup */

<template>
  <div class="tour-popup">
    <div
      id="modal_welcome"
      class="modal welcome-modal"
      data-backdrop="static"
      role="dialog"
      :class="{ displayBlock: displaySide }"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <img
              src="/static/images/icons/popup_close.svg"
              alt="close-icon"
              class="close-btn"
              data-dismiss="modal"
              @click="stopTour()"
            />
            <img
              class="img-responsive logo-rams"
              src="/static/images/logos/RAMS_logo.png"
              alt="rams-logo"
            />
            <img
              src="https://ramsdevstorage.blob.core.windows.net/customererrorpage/Header_swoop.png"
              class="header-swoop"
              alt="header-img"
            />
          </div>
          <div class="modal-body">
            <p class="body-txt">Welcome {{ userName }}!</p>
            <p class="body-txt sub-text">
              Learn about the features available within RAMS with a walk-through tutorial.
            </p>
          </div>
          <div class="modal-footer">
            <div>
              <router-link to="/layout/dashboard">
                <button
                  type="button"
                  class="btn start-btn emergo-green-button"
                  @click="
                    startTour();
                    emitEvent();
                  "
                >
                  Start Tour
                </button>
              </router-link>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-link skip-link"
                data-dismiss="modal"
                @click="stopTour()"
              >
                Skip Tour
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { updateRamsTour } from '../../apis/dashboard';
import EventBus from '../../utils/event-bus';
import { getUserData } from '../../apis/profile';

export default {
  props: ['displaySide'],
  data() {
    return {
      userData: {}
    };
  },
  methods: {
    emitEvent() {
      EventBus.$emit('tourStart');
      // this.$emit('mobilesidebar');
    },
    async startTour() {
      $('#modal_welcome').modal('hide');
      $('#modal_dashboard').modal({
        backdrop: 'static',
        keyboard: false
      });
      EventBus.$emit('openRender', true);
      await this.stopTour();
    },
    async stopTour() {
      const data = {
        new_user: false
      };
      await updateRamsTour(data);
    }
  },
  computed: {
    userName() {
      return `${this.userData.first_name} ${this.userData.last_name}`;
    }
  },
  async mounted() {
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
  }
};
</script>

<style lang="scss" scoped>
.welcome-modal {
  .modal-dialog {
    width: 580px;
  }
}
.displaySide {
  display: block !important;
}
.tour-popup {
  .logo-rams {
    position: absolute;
    margin: 40px auto;
    left: 0;
    right: 0;
    text-align: center;
  }
  .start-btn {
    width: 185px;
    margin-top: 35px;
  }
  .modal-dashbrd {
    .btn-modal-footer {
      margin-top: 0px;
    }
  }
}
.body-txt {
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-32, 37px, $font-weight-medium);
  color: $dark-black-alpha;
  margin-top: 10px;
}
.sub-text {
  @include fontItems($font-18, 21px, $font-weight-small);
  width: 320px;
  margin: 20px auto 0;
}
.check-txt {
  @include fontItems($font-24, 28px, $font-weight-small);
  text-align: center;
  color: $primary;
}
.skip-link {
  color: #0c3859;
  font-size: $font-16;
  margin-bottom: 8px;
  margin-top: 2px;
}

@media screen and (max-width: 767px) {
  .welcome-modal {
    display: none !important;
  }
}
</style>
